import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
var findByName = function findByName(componentList, name) {
  var defaultComponent = componentList.defaultComponent,
    nonEditables = componentList.nonEditables,
    editables = componentList.editables;
  if (name in editables) {
    return editables[name];
  }
  return nonEditables[name.replace(/Editable$/, '')] || defaultComponent;
};
var isLazyLoadable = function isLazyLoadable(obj) {
  return typeof obj.render === 'function' && obj.displayName === 'Loadable';
};
var isComponentType = function isComponentType(obj) {
  return typeof obj === 'function' || isLazyLoadable(obj);
};
var applyDisplayName = function applyDisplayName(base, displayName, componentList) {
  var _displayAs$displayNam;
  var defaultComponent = componentList.defaultComponent;
  var _base$displayAs = base.displayAs,
    displayAs = _base$displayAs === void 0 ? {} : _base$displayAs;
  return (_displayAs$displayNam = displayAs[displayName]) !== null && _displayAs$displayNam !== void 0 ? _displayAs$displayNam : defaultComponent;
};
var getDefaultDisplay = function getDefaultDisplay(component) {
  if (component.displayAs) {
    return component.displayAs["default"];
  }
  return component;
};
var getComponent = function getComponent(componentList, componentName) {
  var deviceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var displayName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var defaultComponent = componentList.defaultComponent;
  var result = findByName(componentList, componentName);
  if (isComponentType(result)) {
    return result;
  }
  var tentativeComponent = displayName ? applyDisplayName(result, displayName, componentList) : getDefaultDisplay(result);
  if (isComponentType(tentativeComponent)) {
    return tentativeComponent;
  }
  return tentativeComponent[deviceType] || defaultComponent;
};
var NullComponent = function NullComponent() {
  return null;
};
var DefaultDisabledWrapper = function DefaultDisabledWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var defaultComponentsList = {
  defaultComponent: NullComponent,
  nonEditables: {},
  editables: {}
};
var COMPONENTS_TO_IGNORE = ['CategoryLabelImage', 'CategoryLabelImageEditable', 'CollectionBox', 'CollectionBoxEditable', 'DebugInfo', 'DebugInfoEditable', 'Document', 'DocumentEditable', 'Footer', 'FooterEditable', 'Header', 'HeaderEditable', 'MshopItem', 'LabelImage', 'LabelImageEditable', 'Layout', 'LayoutEditable', 'ProfileHeader', 'ProfileHeaderEditable', 'TabWithItems', 'Widgets', 'WidgetsEditable', 'WrapperComponent'];
var COMPONENTS_WITHOUT_WRAPPER = ['EshopItem'];
var isComponentOutsideLayout = function isComponentOutsideLayout(componentName) {
  return COMPONENTS_TO_IGNORE.includes(componentName);
};
var defaultAdviceMessage = {
  hasAdviceMessage: false,
  adviceMessageType: '',
  adviceMessage: '',
  link: {}
};
var getAdviceMessageComponent = function getAdviceMessageComponent(properties) {
  var adviceMessage = properties === null || properties === void 0 ? void 0 : properties.advice_message;
  if (adviceMessage) {
    return {
      hasAdviceMessage: true,
      adviceMessageType: adviceMessage.type,
      adviceMessage: adviceMessage.text,
      link: adviceMessage.link
    };
  }
  return defaultAdviceMessage;
};
var getFirstChildAdviceMessage = function getFirstChildAdviceMessage(children) {
  if ((children === null || children === void 0 ? void 0 : children.length) > 0) {
    return getAdviceMessageComponent(children[0].properties);
  }
  return defaultAdviceMessage;
};
var getAdviceMessage = function getAdviceMessage(children, properties) {
  var adviceMessage = getAdviceMessageComponent(properties);
  if (!adviceMessage.hasAdviceMessage) {
    adviceMessage = getFirstChildAdviceMessage(children);
  }
  return adviceMessage;
};
var shouldRenderComponentWithoutWrapper = function shouldRenderComponentWithoutWrapper(componentName) {
  return COMPONENTS_WITHOUT_WRAPPER.includes(componentName);
};
var TYPES = {
  info: 'info',
  warning: 'warning',
  error: 'error'
};
var _excluded = ["componentsList", "deviceType", "node", "DisabledWrapper", "i18n", "globalConfig", "isCustomHtml"];
const _RenderTree = /*#__PURE__*/function () {
  const _RenderTree = function RenderTree(_ref) {
    var _node$properties, _ComponentRender, _ComponentRender2;
    var componentsList = _ref.componentsList,
      deviceType = _ref.deviceType,
      node = _ref.node,
      DisabledWrapper = _ref.DisabledWrapper,
      i18n = _ref.i18n,
      globalConfig = _ref.globalConfig,
      isCustomHtml = _ref.isCustomHtml,
      extraProps = _objectWithoutProperties(_ref, _excluded);
    var Component = getComponent(componentsList, node.component, deviceType, node === null || node === void 0 || (_node$properties = node.properties) === null || _node$properties === void 0 ? void 0 : _node$properties.display);
    var properties = _objectSpread2(_objectSpread2({}, node.properties), {}, {
      restClient: {
        _dummy: true
      },
      componentId: node.id,
      deviceType: deviceType,
      name: node.component,
      nodeItems: node.children,
      nodeStyles: node.properties && node.properties.styles,
      hidden: node.hidden,
      componentProperties: node.component_properties
    }, extraProps) || {};
    var children = Array.from(node.children) || [];
    var ComponentRender = function ComponentRender() {
      return /*#__PURE__*/React.createElement(Component, _extends({}, properties, {
        globalConfig: globalConfig,
        isCustomHtml: isCustomHtml,
        key: node.id,
        i18n: i18n
      }), children.map(function (child) {
        return /*#__PURE__*/_createRawReactElement(_RenderTree, {
          componentsList: componentsList,
          node: child,
          i18n: i18n,
          deviceType: deviceType,
          DisabledWrapper: DisabledWrapper,
          globalConfig: globalConfig,
          isCustomHtml: isCustomHtml
        }, child.id);
      }));
    };
    var EditableRender = function EditableRender() {
      var _getAdviceMessage = getAdviceMessage(children, properties),
        hasAdviceMessage = _getAdviceMessage.hasAdviceMessage,
        adviceMessageType = _getAdviceMessage.adviceMessageType;
      var hasAdviceWarningMessage = hasAdviceMessage && adviceMessageType === TYPES.warning;
      if (!hasAdviceWarningMessage && properties.hidden) {
        return /*#__PURE__*/_createRawReactElement(DisabledWrapper, {
          componentId: properties.componentId,
          i18n: i18n
        }, void 0, _ComponentRender || (_ComponentRender = /*#__PURE__*/_createRawReactElement(ComponentRender, {})));
      }
      return _ComponentRender2 || (_ComponentRender2 = /*#__PURE__*/_createRawReactElement(ComponentRender, {}));
    };
    var componentInside = !isComponentOutsideLayout(node.component);
    var wrapperClasses = ClassNames({
      'component-wrapper': componentInside
    });
    if (shouldRenderComponentWithoutWrapper(node.component)) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, properties, {
        globalConfig: globalConfig,
        key: node.id,
        i18n: i18n
      }));
    }
    if (componentInside && Component !== componentsList.defaultComponent && (node === null || node === void 0 ? void 0 : node.withWrapper) !== false) {
      return /*#__PURE__*/_createRawReactElement("div", {
        className: wrapperClasses
      }, void 0, /*#__PURE__*/_createRawReactElement(EditableRender, {}));
    }
    return /*#__PURE__*/_createRawReactElement(EditableRender, {});
  };
  _RenderTree.defaultProps = {
    componentsList: defaultComponentsList,
    DisabledWrapper: DefaultDisabledWrapper,
    deviceType: 'desktop',
    i18n: {
      gettext: text => text
    }
  };
  return _RenderTree;
}();
var nodePropTypes = {
  id: PropTypes.string,
  component: PropTypes.string,
  properties: PropTypes.objectOf(PropTypes.any),
  hidden: PropTypes.bool
};
nodePropTypes.children = PropTypes.arrayOf(PropTypes.shape(nodePropTypes));
var _RenderTree$1 = _RenderTree;
export { _RenderTree$1 as RenderTree, _RenderTree$1 as default };
